import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
import type { ReactElement } from 'react'
import { NoResult } from '~/components/Global/Elements/NoResult/NoResult'

export const ShortlistThanks = (): ReactElement => (
  <NoResult
    icon={faCircleCheck}
    message="Merci, votre retour a bien été transmis."
  />
)
